import { defineComponent as _defineComponent } from 'vue'
import { useContext } from '@nuxtjs/composition-api';
import ConnectWeb3ProviderButton from '~/components/Web3Wallet/ConnectWeb3ProviderButton.vue';
import { IProviderOption } from '~/store/web3_wallet/types';


export default /*#__PURE__*/_defineComponent({
  __name: 'ReplaceGalaWalletStep3',
  props: {
    step: null,
    providerOptions: null,
    selectedProvider: null
  },
  emits: ["connect"],
  setup(__props: any, { emit }: { emit: ({
  (e: 'connect', option: IProviderOption): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  step: number;
  providerOptions: IProviderOption[];
  selectedProvider: IProviderOption | null;
};





const { i18n } = useContext();

return { __sfc: true,props, emit, i18n, ConnectWeb3ProviderButton }
}

})